// extracted by css-extract-rspack-plugin
export default {"licenseList":"Bx61t4nssC0fqD3f","issueSection":"Hjqqpo60CMvEd0r_"};